import backgroundImage from 'assets/background/footer.png'
import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: auto;
    background-color: #ba9d31;
    background-image: url(${backgroundImage});
    background-size: cover;
    background-repeat: repeat;
`

export const FooterContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 1600px;
    margin: auto;
    background-color: transparent;
`

export const FooterWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    color: #fff;
    padding-top: 3rem;

    @media (max-width: 768px) {
        flex-direction: column;
        padding-top: 2rem;
    }
`

export const ColumnWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 20rem;
    max-width: 25rem;
    margin: 0 1rem;
    margin-bottom: 2rem;

    @media (max-width: 768px) {
        min-width: 95%;
        max-width: 95%;
        margin-bottom: 1rem;
    }
`

export const Title = styled.p`
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 500;
    color: #fff;
    margin: 0;
    margin-bottom: 1.5rem;

    @media (max-width: 768px) {
        font-size: 18px;
        margin-bottom: 1rem;
    }
`

export const SimpleBox = styled.div`
    position: relative;
    background: white;
    width: 250px;
    height: 120px;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`

export const CenteredImage = styled.img`
    position: absolute;
    padding: 1rem;
    padding-top: 1.5rem;
    top: 50%;
    left: 50%;
    width: 100%;
    height: auto;
    transform: translate(-50%, -50%);
`

export const Description = styled.p`
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    margin: 0;
    margin-bottom: 1rem;

    @media (max-width: 768px) {
        font-size: 12px;
        margin-bottom: 0.75rem;
    }
`

export const Info = styled.p`
    font-family: 'Poppins', sans-serif;
    font-size: 15px;
    font-weight: 700;
    color: #fff;
    margin: 0;
    margin-bottom: 1rem;

    @media (max-width: 768px) {
        font-size: 14px;
        margin-bottom: 0.75rem;
    }
`

export const EventBar = styled.div`
    font-family: 'Poppins', sans-serif;
    font-size: 12.5px;
    font-weight: 500;
    background-color: rgba(255, 255, 255, 0.5);
    width: fit-content;
    padding: 0.5rem;
    color: #685612;
    margin: 0 0 1rem 0;
    border-radius: 6px;
    max-width: 25rem;
    cursor: pointer;
    word-wrap: break-word;
    white-space: normal;
    overflow: visible;

    @media (max-width: 768px) {
        font-size: 14px;
        max-width: 95%;
        margin: 0 1rem 1rem 0;
        margin-bottom: 0.75rem;
    }
`

export const Logo = styled.img`
    max-height: 105px;
    max-width: 225px;
    margin-bottom: 1rem;
    cursor: pointer;

    @media (max-width: 768px) {
        max-height: 80px;
        max-width: 180px;
    }
`

export const WhiteLineContainer = styled.div`
    width: 100%;
    background-color: #ba9d31;
`

export const WhiteLine = styled.hr`
    border: none;
    border-top: 2px solid #fff;
    margin: 0;
`
